import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useEffect } from 'react'
import MenuBookIcon from '@mui/icons-material/MenuBook';
import divider from '../../assets/bg/divider.png'
import ENDPOINT from '../../data/ENDPOINT'
import Alert from '@mui/material/Alert';
import { Avatar } from '@mui/material'
import axios from 'axios'
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Close from '@mui/icons-material/Close';
import SetPage from '../../data/SetPage';
import Gallery from '../gallery/Gallery'
import DetectDevice from '../../data/DetectDevice'
import MobileGallery from '../gallery/MobileGallery'
import { Helmet } from 'react-helmet'
import TextField from '@mui/material/TextField';
import PersonIcon from '@mui/icons-material/Person';
import styled from 'styled-components';
import img1 from '../../assets/about/images/team.png';
import img2 from '../../assets/about/images/team2.png';
import img3 from '../../assets/about/images/team3.png';
import pradeep from '../../assets/about/images/pradeep.png'
import minhaz from '../../assets/about/images/minhaz.png'
import company from '../../assets/about/images/image1.png';
import certificate from '../../assets/about/images/gobal-certificate.webp';
import holic from '../../assets/about/images/image2.jpeg'
import { Container, Row, Col, Button, Navbar, Nav } from "react-bootstrap";
import {

  Mail,
  Phone,
  MapPin,
  Star,
  ChevronLeft,
  Instagram,
  Linkedin,
  Twitter,
  Facebook,
} from "lucide-react";
import group136 from '../../assets/about/images/Group 136.jpg'
import facebook from '../../assets/about/images/facebook (3).png'
import twitter from '../../assets/about/images/twitter.png'
import instagram from '../../assets/about/images/instagram.png'
import linkedin from '../../assets/about/images/linkedin.png'

import '../../assets/css/style.css'
import image6 from '../../assets/about/images/image6.png';
import rating from '../../assets/about/images/ratings.jpeg'
import ContactPage from '../contact/ContactPage';

import goal from "../../assets/aboutimages/about-target.png";
// importScripts
import group from '../../assets/about/images/Group2.png'
import trainer from "../../assets/aboutimages/trainerVLSI.jpeg";
import Students from "../../assets/aboutimages/image.png";
import semi from "../../assets/aboutimages/semi.avif";
import trainer2 from "../../assets/aboutimages/trainer2 copy.jpeg";
import trainer3 from "../../assets/aboutimages/trainer3.jpeg";





const AboutCompanyPage = () => {

  const [teamMembers, setTeamMembers] = useState([]);

  const getTeamMembers = async () => {
    try {
      const res = await axios.get(ENDPOINT + "get-team-members.php");
  
      if (res.data.status === "success") {
        setTeamMembers(res.data.data);
      } else {
        console.log("No team data");
      }
    } catch (err) {
      console.log("Error fetching team:", err);
    }
  };

    const [statistics, setstatistics] = useState(null)
    useEffect(() => {
      window.scrollTo(0, 0);
      onSubmit();
      getTeamMembers(); // ✅ ADD THIS
    }, []);

    const onSubmit = async () => {


        let res = await uploadFile();

        if (res) {
            //  //  //  //console.log("about"+JSON.stringify(res))
            if (res.data.status === "success") {


                setstatistics(res.data)
            }
            else {

            }
        }

    }
    const device = DetectDevice()

    const uploadFile = async () => {

        ////  //  //console.log("apply internship")
        const formData = new FormData();

        return await axios.post(ENDPOINT + "about-page-statistics.php", formData, {
            headers: {
                'content-type': 'multipart/form-data'
            }
        });
    }





    const [show, setshow] = useState(false)
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',

        bgcolor: 'background.paper',

        boxShadow: 24,
        p: 4,
    };



    useEffect(() => {
        SetPage("About Company")
    }, [])



    const [showAll, setShowAll] = useState(false);

    const handleViewAll = () => {
        setShowAll(!showAll);
    };



    return (
        <StyledAboutPage>

            <>
                <Helmet>‍
                    <title>About Us - SiliconMinds </title>‍
                    <meta name="description" content="SiliconMinds" />
                    <meta name="twitter:card" content="" />
                    <meta name="twitter:site" content="@skillsuprise" />
                    <meta name="twitter:creator" content="@skillsuprise" />
                    <meta name="twitter:title" content="" />
                    <meta name="twitter:description" content="" />
                    <meta name="twitter:image" content="" />
                    <meta property="og:title" content="" />
                    <meta property="og:description" content="" />
                    <meta property="og:image" content="" />
                    <meta property="og:url" content="" />
                    <meta property="og:site_name" content="Skills Uprise" />
                    <meta property="og:locale" content="en_US" />
                    <meta property="og:type" content="article" />
                    <meta property="fb:app_id" content="ID_APP_FACEBOOK" />
                </Helmet>
                <Modal
                    open={show}
                    onClose={() => setshow(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box className="col-lg-5 col-xl-4 col-md-6 col-sm-10 col-11"
                        sx={style}>

                        <div className="d-flex justify-content-between">
                            <h4 className="text-dark">History of Skills Uprise</h4>
                            <Close type="button" className="text-danger" onClick={() => setshow(false)} />
                        </div>
                        <hr />
                        <video height="auto" autoPlay width="100%" src="https://skillsuprise.com/data/videos/history.mp4" title="Skills Uprise Trainings Demo" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen controls controlsList="nodownload"></video>


                    </Box>
                </Modal>



    <div style={{ overflowX: "hidden", fontFamily: "sans-serif" }}>
      {/* NAVBAR */}
      {/* <Navbar
        fixed="top"
        expand="md"
        style={{
          background: scrolled ? "rgba(255,255,255,0.9)" : "transparent",
          backdropFilter: scrolled ? "blur(8px)" : "none",
          transition: "0.3s",
          padding: scrolled ? "12px 0" : "24px 0",
          borderBottom: scrolled ? "1px solid #eee" : "none",
        }}
      >
        <Container>
          <Navbar.Brand style={{ fontWeight: "700", fontSize: "22px" }}>
            <span
              style={{
                background: "#f97316",
                padding: "6px",
                borderRadius: "8px",
                marginRight: "6px",
                display: "inline-flex",
              }}
            >
              <Zap size={18} color="#fff" />
            </span>
            Silicon <span style={{ color: "#f97316" }}>Minds</span>
          </Navbar.Brand>

          <Navbar.Toggle />
          <Navbar.Collapse>
            <Nav className="ms-auto" style={{ gap: "30px" }}>
              {["Home", "About", "Feature", "Blog"].map((item) => (
                <Nav.Link
                  key={item}
                  href="#"
                  style={{
                    fontSize: "13px",
                    textTransform: "uppercase",
                    fontWeight: "500",
                    color: "#475569",
                  }}
                >
                  {item}
                </Nav.Link>
              ))}
            </Nav>
            <div className="ms-4 d-none d-md-flex gap-2">
              <Button variant="light" style={{ fontWeight: "600" }}>
                Sign in
              </Button>
              <Button
                style={{
                  background: "#0f172a",
                  border: "none",
                  borderRadius: "30px",
                  padding: "8px 20px",
                }}
              >
                Start for free
              </Button>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar> */}

      {/* HERO */}
      <section style={{ paddingTop: "40px", paddingBottom: "80px" }}>
        <Container className="text-center">
          <h1 style={{ fontSize: "48px", fontWeight: "800" }}>
            About <span style={{ color: "#f97316" }}>Silicon Minds</span>
          </h1>
          <p className="fs-5" style={{ maxWidth: "700px", margin: "20px auto", color: "#46515f" }}>
            Discover the story behind our journey, the principles that guide us,
            and how we're dedicated to empowering your business to grow and thrive.
          </p>

          <img
            src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&q=80&w=2000"
            alt=""
            style={{
              width: "100%",
              height: "400px",
              objectFit: "cover",
              borderRadius: "32px",
              marginTop: "60px",
              boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
            }}
          />
        </Container>
      </section>

      {/* CONTACT CARDS */}
      <section style={{ padding: "60px 0" }}>
        <Container>
          <Row className="g-4">
            {[
              { icon: <Mail color="#f97316" />, title: "Email", value: "Email ID : oceancoretech@gmail.com " },
              { icon: <Phone color="#f97316" />, title: "Phone", value: "91777 49942" },
              { icon: <MapPin color="#f97316" />, title: "Address", value: "Flot No. 204, Rams Plaza, Visakhapatnam" },
            ].map((item, i) => (
              <Col md={4} key={i}>
                <div
                  style={{
                    background: "#f8fafc",
                    padding: "24px",
                    borderRadius: "20px",
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #eee",
                  }}
                >
                  <div
                    style={{
                      background: "#fff",
                      padding: "12px",
                      borderRadius: "12px",
                      marginRight: "12px",
                    }}
                  >
                    {item.icon}
                  </div>
                  <div>
                    <div style={{ fontWeight: "700" }}>{item.title}</div>
                    <div style={{ color: "#4a6283", fontSize: "14px" }}>
                      {item.value}
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* STATS */}
      <section style={{ padding: "50px 0", textAlign: "center" }}>
        <Container>
          <Row>
            {[
              { label: "Employees", value: "50K+" },
              { label: "Users globally", value: "05M+" },
              { label: "Positive review", value: "98%" },
              { label: "Years in business", value: "15+" },
            ].map((stat, i) => (
              <Col xs={6} md={3} key={i}>
                <h2 style={{ fontWeight: "800" }}>{stat.value}</h2>
                <small className='fs-5' style={{ letterSpacing: "2px", color: "#4f627c" }}>
                  {stat.label}
                </small>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

       <section style={{ padding: "50px 0" }}>
        <Container>
          <Row className="align-items-center g-5">
            <Col md={6}>
              <p   className="fs-2" style={{ color: "#f97316", fontWeight: "750", letterSpacing: "1px" }}>
                OUR STORY
              </p>
              <h3  className="text-start" style={{ fontWeight: "800", marginBottom: "16px" }}>
                Building VLSI Engineers for the Semiconductor Industry
              </h3>
              <p  className="text-start fs-5" style={{ color: "#46515f", lineHeight: "1.7" }}>
                We bridge the gap between academic learning and real-world VLSI industry
                needs with hands-on labs, internships, and live projects.
              </p>
              <Button
                style={{
                  background: "#0f172a",
                  border: "none",
                  padding: "10px 22px",
                  borderRadius: "8px",
                  marginTop: "10px",
                }}
              >
                Learn more
              </Button>
            </Col>

            <Col md={6}>
              <img
                src={trainer}
                alt=""
                style={{
                  width: "100%",
                  objectFit:'contain',
                  borderRadius: "18px",
                  boxShadow: "0 12px 25px rgba(0,0,0,0.12)",
                }}
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* OUR TARGET */}
      <section style={{ padding: "50px 0", background: "#fff" }}>
        <Container>
          <Row className="align-items-center g-5 flex-md-row-reverse">
            <Col md={6}>
              <p className="fs-2" style={{ color: "#f97316", fontWeight: "720", letterSpacing: "1px" }}>
                OUR TARGET
              </p>
              <h3 className="text-start" style={{ fontWeight: "800", marginBottom: "16px" }}>
                Our aim is to boost sales
              </h3>
              <p className="text-start fs-5" style={{ color: "#46515f", lineHeight: "1.7" }}>
                Our VLSI is designed to adapt to your unique needs and scale seamlessly
                as your business grows. We prioritize fostering long-term customer
                loyalty by understanding needs and delivering experiences at every
                interaction.
              </p>
              <Button
                style={{
                  background: "#0f172a",
                  border: "none",
                  padding: "10px 22px",
                  borderRadius: "8px",
                  marginTop: "10px",
                }}
              >
                Learn more
              </Button>
            </Col>

            <Col md={6}>
              <img
                src={semi}
                alt=""
                style={{
                    objectFit:"contain",
                  width: "100%",
                  borderRadius: "18px",
                  boxShadow: "0 12px 25px rgba(0,0,0,0.12)",
                }}
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* STATS */}
      <section style={{ padding: "40px 0", textAlign: "center" }}>
        <Container>
          <h4 style={{ fontWeight: "800", marginBottom: "50px" }}>
            OUR PROVEN SUCCESS STORIES
          </h4>
          <Row>
            {[
              { value: "50K+", label: "EMPLOYEES" },
              { value: "05M+", label: "USERS GLOBALLY" },
              { value: "98%", label: "POSITIVE REVIEW" },
              { value: "15+", label: "YEARS IN BUSINESS" },
            ].map((item, i) => (
              <Col xs={6} md={3} key={i} style={{ marginBottom: "30px" }}>
                <h2 style={{ fontWeight: "800" }}>{item.value}</h2>
                <p style={{ fontSize: "12px", letterSpacing: "2px", color: "#64748b" }}>
                  {item.label}
                </p>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* MEET OUR EXPERTS */}
      <section className='pb-3' style={{ padding: "10px 0"  }}>
        <Container>
          <h4 style={{ textAlign: "center", fontWeight: "800", marginBottom: "10px" }}>
            MEET OUR EXPERTS
          </h4>
          <p className='fs-5 pt-2 pb-3'
            style={{
              textAlign: "center",
              color: "#46515f",
              maxWidth: "600px",
              margin: "0 auto 50px",
            }}
          >
            Discover the passionate team of innovators, strategists, and customer
            success professionals working tirelessly to help you achieve your goals.
          </p>

          <Row className="g-4">
  {teamMembers.length > 0 ? (
    teamMembers.map((member, i) => (
      <Col md={3} key={i}>
        <div
          style={{
            borderRadius: "18px",
            overflow: "hidden",
            boxShadow: "0 10px 25px rgba(0,0,0,0.12)",
          }}
        >
          <img
            src={member.profile_pic}
            alt={member.first_name}
            style={{
              width: "100%",
              height: "300px",
              // objectFit: "cover",
            }}
          />
        </div>

        <h5 style={{ fontWeight: "800", marginTop: "14px" }}>
          {member.first_name} {member.last_name}
        </h5>

        <p style={{ fontSize: "13px", color: "#334050" }}>
          {member.designation || "Team Member"}
        </p>
      </Col>
    ))
  ) : (
    <p style={{ textAlign: "center" }}>No team members found</p>
  )}
</Row>
        </Container>
      </section>

      {/* FOOTER */}
    
    </div>
            </>

        </StyledAboutPage>
    )
}

export default AboutCompanyPage

const StyledAboutPage = styled.div`
.box{
  background-color:#E4E4FF}

.bg{
 background-color:#070B60} 
 
 .fs{
 font-size:60px;
 }

.fs5{
 font-size:13px;}

.growth{
 color:#0649ff}

 .mission{
  border-top:60px solid #8CC63E
  }
  .mission{
  border-bottom:20px solid #8CC63E
  }
  .missiontx{
   color:#8CC63E}
.culture{
  border-top:60px solid #FBB547
  }
  .culture{
  border-bottom:20px solid #FBB547
  }
  .culturetx{
  color:#FBB547}
  .box2{
  background-color:#071F43}

.pradeep{
  height:40px;
  }

.lt{
border-radius: 60px 5px 0px 0px;
}
.left{
  border-radius: 60px 5px 5px 5px;
}

@media only screen and (max-width: 992px) {
  .margin-about {
    margin-top: 30px;
  }
}
@media only screen and (max-width: 576px) {
  .padding-about {
    padding:0px !important;
  }
}

@media only screen and (max-width: 576px) {
  .last-name {
    margin-top:50px !important;
  }
}

.adress{
height:250px;

}

/* .order{
border-top-left-radius:10px;
border-top-right-radius:10px;
} */

`